export default "__VITE_ASSET__83a554c9__"